export default __webpack_public_path__ + "static/media/graphp.08204f85.svg";